import { getNameInitials } from "@thalamos/common";
import type { ExtendedThalamosUser } from "@thalamos/aspire-common";
import { isExtendedTeamMembership } from "@thalamos/aspire-common";

export const stringAvatar = (name: string) => {
  return {
    children: getNameInitials(name),
  };
};

export const shouldShowTeamSelector = (
  user: ExtendedThalamosUser | null,
): boolean => {
  if (!user || !user.sessionContext) return false;

  const { teamType } = user.sessionContext;

  if (teamType === "cqc") return false;

  if (teamType !== "soad") return true;

  // If SOAD, only show if they have another non-SOAD membership
  const hasNonSoadMembership = user.memberships.some(
    (membership): boolean =>
      isExtendedTeamMembership(membership) && membership.teamType !== "soad",
  );

  return hasNonSoadMembership;
};
